"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestCopyDto = instanceOfDigestCopyDto;
exports.DigestCopyDtoFromJSON = DigestCopyDtoFromJSON;
exports.DigestCopyDtoFromJSONTyped = DigestCopyDtoFromJSONTyped;
exports.DigestCopyDtoToJSON = DigestCopyDtoToJSON;
exports.DigestCopyDtoToJSONTyped = DigestCopyDtoToJSONTyped;
/**
 * Check if a given object implements the DigestCopyDto interface.
 */
function instanceOfDigestCopyDto(value) {
    return true;
}
function DigestCopyDtoFromJSON(json) {
    return DigestCopyDtoFromJSONTyped(json, false);
}
function DigestCopyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'text': json['text'] == null ? undefined : json['text'],
        'key': json['key'] == null ? undefined : json['key'],
    };
}
function DigestCopyDtoToJSON(json) {
    return DigestCopyDtoToJSONTyped(json, false);
}
function DigestCopyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'text': value['text'],
        'key': value['key'],
    };
}
